import React from 'react';

/**
 * Section 12 — stands in for the second testimonial run until a pilot cohort
 * exists: the claim in action, instead of a quote we can't back yet.
 */
export function TwentyMinutes() {
  return <section aria-labelledby="twenty-heading" className="w-full bg-cream" data-id="element-258" data-mp="2iiofu7o6gn9s">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-259" data-mp="2djbyg2g2s8el">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-260" data-mp="2dlevh6fnb1st">
          <div className="rounded-3xl overflow-hidden border border-cream-dark shadow-card" data-id="element-261" data-mp="1puiyluwc1gep">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/24b0d758-5c08-498b-a254-419d225e311f.jpg" alt="The Weekly Reset Checklist on a kitchen table with a pencil, a timer set to twenty minutes, and a mug of coffee." className="w-full h-full object-cover" width={1200} height={900} loading="lazy" data-id="element-262" data-mp="1kvy4md7obsyp" />
          </div>

          <div data-id="element-263" data-mp="36a2cgptd350k">
            <h2 id="twenty-heading" className="font-serif font-bold text-ink text-2xl sm:text-3xl lg:text-[40px] lg:leading-[1.1]" data-id="element-264" data-mp="e78isqpe91im">
              What twenty minutes actually looks like
            </h2>
            <p className="mt-6 text-ink-soft text-base sm:text-lg leading-relaxed" data-id="element-265" data-mp="n981dng24dno">
              Sunday, 4:40 p.m. The checklist is already on the fridge, so
              nothing has to be remembered. Last week gets closed: three lines
              logged, the papers routed, the two things that didn&apos;t happen
              moved or dropped on purpose. Next week gets set: the anchors are
              the same anchors, so there&apos;s nothing to invent. At 5:00 the
              timer goes off and nothing else on the list gets done, because
              nothing else gets done during a reset except the reset.{' '}
              <strong className="text-ink font-semibold" data-id="element-266" data-mp="37w2ve7tu4cmf">
                That rule is the whole reason it survives to week fourteen.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}